<style lang="scss" scoped>
    .content {
        left: 0;
        width: 100% !important;
    }

    .svg-section {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .form-row {
        margin-left: 0;
        margin-right: 0;
    }

    .m-b-5 {
        margin-bottom: 5px;
    }

    .form-section {
        padding: 0 60px;
    }

    .top-bar {
        background-color: #003b71;
        height: 60px;
        width: 100%;
        top: 50px;
        left: 0;
        z-index: 2;
        overflow: hidden;
    }

    .registration-wrapper-row {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .image-section {
        background-image: url("../assets/images/register-img.jpg");
        display: flex;
        flex-direction: column;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        font-family: "Open Sans";
        position: relative;
        height: 100vh;
    }

    .st0 {
        fill: #FFFFFF;
    }

    #logo-svg {
        width: 300px;
        height: 170px;
    }

    .m-b-50 {
        margin-bottom: 50px;
    }

    .reset-pass-paragraph {
        font-weight: bold;
    }
    .parametric-intro {
        margin: 0;
        padding-top: 43px !important;
    }


    /*Responsive design*/
    @media (max-width: 768px) {

        .registration-wrapper-row .image-section {
            height: 402px;
        }
    }

    @media (max-width: 992px) {

        .parametric-intro {
            margin: 0;
        }

        .form-section {
            padding: 0 15px;
        }

        .page-title {
            padding-left: 0 !important;
        }

        .image-section {
            order: 1;
            height: 464px;
            width: 100%;
        }

        .form-section {
            order: 2;
        }

    }
</style>

<template>
    <div class="registration-wrapper">
        <div class="top-bar">
        </div>
        <div class="row registration-wrapper-row">
            <div class="col-md-6 form-section">
                <div class="parametric-intro">
                    <h3 class="page-title">Password reset confirmation</h3>
                </div>

                <div class="account-question">
                    <p class="reset-pass-paragraph">If there is an account associated with
                        {{email}}, you will receive an
                        email with a link to reset your password.
                    </p>
                    <p class="reset-pass-paragraph m-b-50">If you have not received such an email,
                        please verify the email address provided while resetting the password.
                    </p>
                </div>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svf-wrapper">
                        <svg id="logo-svg" class="svg-section" x="0px" y="0px" viewBox="0 0 302 172" style="enable-background:new 0 0 511 173;" xml:space="preserve">
                            <path class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                            </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConfirmPasswordReset",
        props: {
            email: {
                type: String,
                default: ''
            }
        },
    };
</script>

